import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pantry-ingredient-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-ingredient-view-empty" }, null, -1)
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectingIngredientList = _resolveComponent("SelectingIngredientList")
  const _component_PantryIngredientEmptyView = _resolveComponent("PantryIngredientEmptyView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isEmpty())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_SelectingIngredientList, {
            class: "pantry-ingredient-view-list",
            categoryTitle: _ctx.title,
            ingredientList: _ctx.ingredientList,
            onOnSelect: _ctx.onSelectIngredient
          }, null, 8, ["categoryTitle", "ingredientList", "onOnSelect"]),
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_PantryIngredientEmptyView)
        ]))
  ]))
}